import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    actionText: 'Click here',
    description: 'You have been invited by your company?',
  },
  fr: {
    actionText: 'Cliquez ici',
    description: 'Vous avez été invité par votre entreprise\u00A0?',
  },
} as const);

export default locales;
